import Layout from '@@client/app/Layout'
import GeneralPage, {Header, Content, NarrowContent} from '@@client/app/GeneralPage'
import Youtube from '@@client/components/Youtube'

export default function Page() {
    return (
        <Layout title='Videos'>
            <GeneralPage>
                <Header title='Videos'>
                    <p>See how we inspect, grade, and prepare parts, and how you can save money with parts from Autowrecking.com.</p>
                </Header>
                <Content>
                    <NarrowContent>
                        <h2>How we Receive & Inspect Transmissions for Safety and Reliability</h2>
                        <div className='yt'><Youtube videoId='9YAnw5UkBBw' /></div>

                        <h2>Our Part Grading Explanation</h2>
                        <div className='yt'><Youtube videoId='KuPY0oB1bzI' /></div>

                        <h2>We take Recycling Seriously</h2>
                        <div className='yt'><Youtube videoId='kNOrq5uNCtU' /></div>

                        <h2>Our Transmission Preparation and QC</h2>
                        <div className='yt'><Youtube videoId='1P-TFqDuhbE' /></div>

                        <h2>We part out a 2008 Ford F350 Super Duty 6.4L</h2>
                        <div className='yt'><Youtube videoId='5wLdrYXRqFw' /></div>

                        <h2>Additional Videos</h2>

                        <p>Check out our <a href='https://www.youtube.com/channel/UCoSlOZ60uAt7_-Yns8ggfEA'>YouTube channel</a> for more videos.</p>
                    </NarrowContent>
                </Content>
            </GeneralPage>
            <style jsx>
                {`

                    @import '@css/variables.css';

                    .yt {
                        height: 337px;
                        margin-bottom: 30px;
                        padding-bottom: 30px;
                        border-bottom: 2px solid $c--blue--darker;

                        @media(--xs) { height: 280px; }
                        @media(--xxs) { height: 247px; }
                        @media(--xxxs) { height: 195px; }
                    }

                    h2 {
                        color: $c--blue--darker;
                    }
                `}
            </style>
        </Layout>
    )
}
